import React from "react";
import { observer, inject } from "mobx-react";
import { injectIntl } from "react-intl";

import Attachment from "./Attachment";
import EditableWithMentions from "./EditableWithMentions";
import { ACTIVITIES, NOTE_COMMENT_MAX_LENGTH } from "./constants";

@injectIntl
@inject("rootStore")
@observer
export default class Activity extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { activity, note, intl } = this.props;

    return (
      <div className="activity-container" style={{ position: "relative" }}>
        <div className="activity-user-photo-container">
          <img
            className="activity-user-photo"
            src={activity.user.profilePhotoUrl}
          />
        </div>

        <div className="activity-body-container">
          <div className="activity-date">
            {intl.formatRelative(activity.createdAt)}
          </div>
          <div className="activity-message">
            {activity.user.name} {intl.formatMessage({ id: activity.key })}
          </div>
          <div className="activity-description">{this.renderDescription()}</div>

          {this.renderAttachment()}
        </div>
        <hr />
      </div>
    );
  }

  renderDescription = () => {
    const { activity, rootStore } = this.props;

    switch (activity.key) {
      case ACTIVITIES.CARD_COMMENT.CREATE:
        return this.renderComment();
      case ACTIVITIES.CARD.DUE_DATE.SET:
        return activity.description
          ? rootStore.localeStore.moment(activity.description).format("LLL")
          : "";
      default:
        return activity.description || "";
    }
  };

  renderComment = () => {
    const { activity, note, intl, rootStore } = this.props;
    const comment = note.comments.find(c => c.id === activity.trackable.id);
    if (comment) {
      const canEdit = rootStore.authorizationStore.canEditComment(comment);

      return (
        <EditableWithMentions
          value={comment.body}
          note={note}
          comment={comment}
          canDelete={canEdit}
          canEdit={canEdit && true}
          showDelete
          onEdit={value => note.editComment(comment, value)}
          onDelete={() => note.deleteComment(comment)}
          maxLength={NOTE_COMMENT_MAX_LENGTH}
        />
      );
    } else {
      return <span>{intl.formatMessage({ id: "deleted" })}</span>;
    }
  };

  renderAttachment = () => {
    const { activity, note } = this.props;

    if (activity.trackable.attachmentUrl) {
      return <Attachment attachment={activity.trackable} note={note} />;
    }
  };

  // faIconFromKey = (key) => {
  //     let faIconClass = '';
  //
  //     faIconClass = 'fa fa-check';
  //
  //
  //     return faIconClass;
  //
  // };
}

Activity.propTypes = {};
